export const validationTranslationsNL = {
    required: 'Verplicht veld',
    invalidNumber: 'Veld moet een geldig getal zijn',
    invalidEmail: 'Ongeldig email address',
    invalidDate: 'Veld moet een geldige datum zijn',
    amountMustBeGreaterThan0: 'Aantal moet groter dan 0 zijn',
    organisationRequired: 'Organisatie verplicht',
    minOneValueSelected: 'Selecteer minstens 1 item',
    postalCodeIsInvalid: 'Postcode bestaat uit 4 karakters',
};
